import { render, staticRenderFns } from "./TeamContent.vue?vue&type=template&id=320a88eb"
import script from "./TeamContent.vue?vue&type=script&lang=js"
export * from "./TeamContent.vue?vue&type=script&lang=js"
import style0 from "./TeamContent.vue?vue&type=style&index=0&id=320a88eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports